import { EditResourceForm } from "@/features/reserve/components/ResourceSettingsPanel/ResourceSettingsPanel";
import { useResourceSettingsState } from "@/features/reserve/hooks/useResourceSettings";
import { FloorPlanUploadInput } from "@gettactic/components/src/form/FloorPlanUploadInput";
import { Stack } from "@gettactic/components/src/primitives/Stack";
import React from "react";
import { UseFormSetValue, UseFormWatch } from "react-hook-form";

export interface MapPanelProps {
  loading: boolean;
  watch: UseFormWatch<EditResourceForm>;
  setValue: UseFormSetValue<EditResourceForm>;
}

export const MapPanel = ({ loading, watch, setValue }: MapPanelProps) => {
  const resourceContext = useResourceSettingsState();
  const resource = resourceContext.state.selected;
  const file = watch("map_file");
  const mapUrl = watch("map_url");

  const handleFileChange = (newFile: File | null) => {
    setValue("map_file", newFile);
    // Clear the existing map_url when a new file is selected or when removing
    if (newFile || mapUrl) {
      setValue("map_url", null);
    }
  };

  if (!resource) return null;

  return (
    <Stack className="mt-5">
      <FloorPlanUploadInput
        value={file}
        onChange={handleFileChange}
        previewUrl={mapUrl}
        disabled={loading}
        label="Floor Plan Map"
        description="Upload an SVG file to display as the floor plan"
      />
    </Stack>
  );
};
